import { render, staticRenderFns } from "./AppVersionManager.vue?vue&type=template&id=2b9bf02c&scoped=true"
import script from "./AppVersionManager.vue?vue&type=script&lang=js"
export * from "./AppVersionManager.vue?vue&type=script&lang=js"
import style0 from "./AppVersionManager.vue?vue&type=style&index=0&id=2b9bf02c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9bf02c",
  null
  
)

export default component.exports